import Main from "@root/Main";
import { ComponentDefineDic, PopupDefineDic } from "@components/interfaces";
import Components from "@components/Compoents";
import Popups from "../popups/Popups";
import RatingStars from "../ui/RatingStars";
import ValueRange from "../ui/inputs/ValueRange";
import PickPrice from "./PickPrice";
import SearchSearchbar from "./SearchSearchbar";
import page_data_schema from "@schema/search/page-data.json";
import ApiProxy from "../../ts/ApiProxy";
import SearchFilter from "./SearchFilter";
import SearchManager from "./SearchManager";
import SearchResult from "@/src/scripts/components/search/SearchResult";
import Tools from "../../ts/Tools";
import ResultBlock from "./ResultBlock";
import PromoteList from "../ui/PromoteList";
import ImgHeader from "../shared/ImgHeader";
import Pager from "../ui/Pager";
import { Search } from "./SearchTypes";
import GS from "../../ts/GlobalSetting";

let _componentDic: ComponentDefineDic = {
  "rating-stars": {
    componentClass: RatingStars
  },
  "value-range": {
    componentClass: ValueRange
  },
  "pick-price": {
    componentClass: PickPrice
  },
  "search-bar": {
    componentClass: SearchSearchbar
  },
  "search-filter": {
    componentClass: SearchFilter
  },
  "search-result": {
    componentClass: SearchResult
  },
  "result-block": {
    componentClass: ResultBlock
  },
  "promote-list": {
    componentClass: PromoteList
  },
  "img-header": {
    componentClass: ImgHeader
  },
  "pager": {
    componentClass: Pager
  },
};

let _popupDic: PopupDefineDic = {
};

let root: JQuery;

Main.preInitPage = () => {
  ApiProxy.validatePageData("page-data", page_data_schema);
}

Main.initPage = () => {
  root = $('#page-content');
  let pageData: Search.PageData = ApiProxy.getPageData();
  GS.search.pageSize = pageData.filter_setting.page_size;
  (<SearchResult>Tools.seekComponentByName("search-result")).init();
  SearchManager.init();
  SearchManager.applyUrlQuery();
  SearchManager._searchResult.checkResults();
  SearchManager.intoIdle();
};

Components.registComponents(_componentDic);
Popups.registComponents(_popupDic);